//TODO: make better generation and use it in requisites component too

//order
const SWIFT_KEYS = [
  'beneficiary.name',
  'beneficiary.address',
  'beneficiaryBank.account',
  'beneficiaryBank.code',
  'beneficiaryBank.name',
  'empty',
  'correspondentBanks[0].name',
  'correspondentBanks[0].code',
];

//display names of fields
const INFO_MAP = {
  'beneficiary.name': 'Company name',
  'beneficiary.address': 'Company address',
  'beneficiaryBank.account': 'Account number',
  'beneficiaryBank.name': 'Bank',
  'beneficiaryBank.code': 'SWIFT code',
  empty: '',
  'correspondentBanks[0].name': 'Intermediate bank name',
  'correspondentBanks[0].code': 'Intermediate bank code',
};

type AnyObject = Record<string, unknown>;

function getNestedValue(obj: AnyObject, path: string): unknown {
  const parts = path.split('.');
  let current: unknown = obj;

  for (const part of parts) {
    // Handle array indexes like "correspondentBanks[0]"
    const match = /^(\w+)\[(\d+)\]$/.exec(part);
    if (match) {
      const [, key, indexStr] = match;
      const index = parseInt(indexStr, 10);
      current = current?.[key]?.[index];
    } else {
      current = current?.[part];
    }

    if (current === undefined || current === null) break;
  }

  return current;
}

export function getAccountInfoForCopy(obj: AnyObject): string {
  if (!obj) return '';
  return SWIFT_KEYS.map((path) => {
    const value = getNestedValue(obj, path);

    if ((value === undefined || value === null) && path !== 'empty')
      return null;

    const label = INFO_MAP[path];
    if (path === 'empty') return ' ';
    return `${label}: ${value}`;
  })
    .filter(Boolean) // remove nulls
    .join('\n');
}
